import React from "react";
import { Toaster, Position } from "@blueprintjs/core";
import RandomString from "randomstring";
import { storage } from "../../fire";

import {
  toast_deleteError,
  toast_deleteSuccess,
  toast_uploadError,
  toast_uploadInProgress,
  toast_uploadSuccess,
  toast_warningError
} from "./Sequences/Toast";
import Auth from "../../services/Auth";
import DialogAddInterlude from "./Interludes/DialogAddInterlude";
import CreatePanelInterludesTable from "./Interludes/TableInterludes";
import Session from "../../services/Session";

class CreatePanelInterludes extends React.Component {
  toaster; // React Reference to Toaster component

  constructor(props) {
    super(props);
    this.state = {
      dialogIsOpen: false,
      interlude: {
        name: null,
        file: null,
        fileInternalName: null,
        fileBlob: null,
        downloadURL: null,
        type: null
      },
      isDeletingInterlude: false
    };
    this.storageBaseRef = "";
  }

  handleOpenDialog = () => this.setState({ dialogIsOpen: true });
  handleCloseDialog = () => this.setState({ dialogIsOpen: false });

  handleChangeInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    const { interlude } = this.state;

    this.setState({ interlude: { ...interlude, [name]: value } });
  };
  handleChangeFileInput = e => {
    const name = e.target.name;
    const blob = e.target.files[0] || null;
    let value = e.target.value;
    const { interlude } = this.state;

    // Get only the file name from the full path
    value = value.replace(/^.*[\\/]/, "");
    this.setState({
      interlude: { ...interlude, [name]: value, fileBlob: blob }
    });
  };
  handleAddInterlude = () => {
    this.setState({ submiting: true });

    const { onChangeInterludes, interludes, sessionId } = this.props;
    const { interlude } = this.state;
    const uploadToastKey = this.toaster.show(toast_uploadInProgress(0));
    interlude.fileInternalName = RandomString.generate(30);
    const storageRef = Session.addInterlude({
      sessionId,
      interlude,
      onProgress: snapshot => {
        /**
         * Upload is in progress
         * --
         * Calculate purcentage of uploading
         * Update the upload toast with the new purcentage
         */
        let progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        this.toaster.show(toast_uploadInProgress(progress), uploadToastKey);
      },
      onError: e => {
        /**
         * Upload has errored
         * --
         * Set the new state (no more submiting and interlude obj is reseted)
         * Close the 'Ajouter un interlude' dialog
         * Dismiss the upload toast
         * Show an error toast
         */
        this.setState({
          submiting: false,
          interlude: {
            name: null,
            file: null,
            fileInternalName: null,
            fileBlob: null,
            downloadURL: null,
            type: null
          }
        });
        this.handleCloseDialog();
        this.toaster.dismiss(uploadToastKey);
        this.toaster.show(toast_uploadError());
        console.error("An error has been occured when uploading\n", e.message);
      },
      onComplete: () => {
        /**
         * Upload is complete
         * --
         * Give an id to the interlude (usefull for interlude removing)
         * Get the download URL of the uploaded file (async)
         * Push the interlude to the list of interludes (omit the fileBlob attribute)
         * Call prop handler 'onChangeInterludes' to update the list of interlude of the parent component
         * Set the new state (update list of interlude, no more submiting and interlude obj is reseted)
         * Dismiss the upload toast
         * Show a success toast
         */
        storageRef
          .getDownloadURL()
          .then(url => (interlude.downloadURL = url))
          .then(() => {
            interludes.push({
              id: RandomString.generate(16),
              name: interlude.name,
              file: interlude.file,
              fileInternalName: interlude.fileInternalName,
              downloadURL: interlude.downloadURL,
              type: interlude.type
            });
            if (this.props.number) {
              onChangeInterludes(interludes, this.props.number);
            } else {
              onChangeInterludes(interludes);
            }
            this.setState({
              submiting: false,
              interlude: {
                name: null,
                file: null,
                fileInternalName: null,
                fileBlob: null,
                downloadURL: null,
                type: null
              }
            });
            this.handleCloseDialog();
            this.toaster.dismiss(uploadToastKey);
            this.toaster.show(toast_uploadSuccess());
          });
      }
    });
  };
  handleDeleteInterlude = id => {
    let { interludes } = this.props;
    const { onChangeInterludes, sessionId } = this.props;
    const storageRef = storage.ref(
      `${this.storageBaseRef}/${sessionId}/${interludes.find(i => i.id === id).fileInternalName
      }`
    );
    const deleteInterlude = () => {
      let { interludes } = this.props;

      // Delete the element that has the given id using Array.filter
      interludes = interludes.filter(i => i.id !== id);
      if (this.props.number) {
        onChangeInterludes(interludes, this.props.number);
      } else {
        onChangeInterludes(interludes);
      }
    };

    this.setState({ isDeletingInterlude: true });
    storageRef
      .delete()
      .then(() => {
        this.toaster.show(toast_deleteSuccess());
        deleteInterlude();
        this.setState({ isDeletingInterlude: false });
      })
      .catch(e => {
        const { code } = e;

        this.setState({ isDeletingInterlude: false });
        switch (code) {
          case "storage/unknown":
            this.toaster.show(
              toast_deleteError("Unknow error occured...")
            );
            break;
          case "storage/object-not-found":
            this.toaster.show(
              toast_warningError(
                "We could not find the file but we still deleted the introduction.",
                10000
              )
            );
            deleteInterlude();
            break;
          case "storage/quota-exceeded":
            this.toaster.show(
              toast_deleteError("The allocated storage space is full.")
            );
            break;
          case "storage/unauthenticated":
            this.toaster.show(
              toast_deleteError("Please authenticate !")
            );
            break;
          default:
            this.toaster.show(toast_deleteError(e.message));
            break;
        }
      });
  };
  handleChangeOrder = (currentIndex, newIndex) => {
    let { onChangeInterludes, interludes = [] } = this.props;
    interludes.splice(newIndex, 0, interludes.splice(currentIndex, 1)[0]);
    if (this.props.number) {
      onChangeInterludes(interludes, this.props.number);
    } else {
      onChangeInterludes(interludes);
    }
  };

  render() {
    const { interludes } = this.props;
    const {
      dialogIsOpen,
      submiting,
      interlude,
      isDeletingInterlude
    } = this.state;

    return (
      <div>
        <Toaster
          position={Position.TOP_RIGHT}
          autoFocus={false}
          ref={toaster => (this.toaster = toaster)}
        />
        <DialogAddInterlude
          interlude={interlude}
          dialogIsOpen={dialogIsOpen}
          submiting={submiting}
          onCloseDialog={this.handleCloseDialog}
          onChangeInput={this.handleChangeInput}
          onChangeInputFile={this.handleChangeFileInput}
          onAddInterlude={this.handleAddInterlude}
        />
        <CreatePanelInterludesTable
          interludes={interludes}
          deleting={isDeletingInterlude}
          onDeleteInterlude={this.handleDeleteInterlude}
          onChangeOrder={this.handleChangeOrder}
          onOpenDialog={this.handleOpenDialog}
        />
      </div>
    );
  }

  componentDidMount() {
    this.storageBaseRef = `interludes/${Auth.getUserId()}`;
  }
}

export default CreatePanelInterludes;
